const vidTypes = {
    "DEMO": "DEMO",
    "POLL_MODE": "POLL_MODE",
    "LAMBDA": "LAMBDA",
    "DOCKERFILE": "DOCKERFILE",
    "LOGS": "LOGS",
    "PROGRAMMING": "PROGRAMMING",
    "ZIP_FILE": "ZIP_FILE"
}

export default vidTypes;